import { jsx } from 'react/jsx-runtime';
import { InputProvider } from './Input.Context/Input.Context.es.js';
import { InputCore } from './Input.Core/Input.Core.es.js';
import { InputFieldButton } from './Input.Field/Input.Field.Button/Input.Field.Button.es.js';
import { InputFieldCustom } from './Input.Field/Input.Field.Custom/Input.Field.Custom.es.js';
import { InputFieldText } from './Input.Field/Input.Field.Text/Input.Field.Text.es.js';
import { InputInlineAffix } from './Input.Inline/Input.Inline.Affix/Input.Inline.Affix.es.js';
import { InputInlineButton } from './Input.Inline/Input.Inline.Button/Input.Inline.Button.es.js';
import { InputInlineIcon } from './Input.Inline/Input.Inline.Icon/Input.Inline.Icon.es.js';
import { InputInlineIconButton } from './Input.Inline/Input.Inline.IconButton/Input.Inline.IconButton.es.js';

const Input = ({ value, placeholder, error, disabled, warning, loading, readOnly, label, labelProps, labelSuffix, display, ...props })=>{
    return jsx(InputProvider, {
        disabled: disabled,
        display: display,
        error: error,
        label: label,
        labelProps: labelProps,
        labelSuffix: labelSuffix,
        loading: loading,
        placeholder: placeholder,
        readOnly: readOnly,
        value: value,
        warning: warning,
        children: jsx(InputCore, {
            ...props
        })
    });
};
Input.displayName = 'Input';
Input.Inline = {
    Affix: InputInlineAffix,
    Button: InputInlineButton,
    Icon: InputInlineIcon,
    IconButton: InputInlineIconButton
};
Input.Field = {
    Button: InputFieldButton,
    Custom: InputFieldCustom,
    Text: InputFieldText
};

export { Input, Input as default };
//# sourceMappingURL=Input.es.js.map
